import { render, staticRenderFns } from "./InfoNotice.vue?vue&type=template&id=5de0c9f4"
import script from "./InfoNotice.vue?vue&type=script&lang=js"
export * from "./InfoNotice.vue?vue&type=script&lang=js"
import style0 from "./InfoNotice.vue?vue&type=style&index=0&id=5de0c9f4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports